import css from './empty-placeholder.module.scss';

interface PlasceholderProps {
  title: string;
  pageSearchMsg: string;
}

export default function EmptyPlaceholder({ title, pageSearchMsg }: Readonly<PlasceholderProps>) {
  return (
    <div className={css.placeholder}>
      <span className={css.title}>{title}</span>
      <span className={css.recommendation}>Скористайтесь простими рекомендаціями:</span>
      <ul>
        <li>Перевірте правильність написання запиту</li>
        <li>Спробуйте використати більш загальний запит</li>
        <li>{pageSearchMsg}</li>
      </ul>
    </div>
  );
}
